import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BaseLayout from "../../components/BaseLayout";
import Tabs from "../../components/Tabs";
import CarouselSlider from "./../../components/CarouselSlider";
import Header from "../../components/Header";
import Section from "../../components/Section";
import Category from "./category";
import NotFound from "../../components/NotFound";
import * as PageRoutes from "./../../utils/route_pages";
import "./style.scss";

const NewsPage = (props) => {
  const {
    getCategories,
    categories,
    getListNewsByCategory,
    dataNews,
    getMyBookmark,
    listBookmark,
  } = props;

  const [isActive, setIsActive] = useState(0);
  const [data, setData] = useState([]);

  const tabsCategory = [
    {
      id: 0,
      name: "Latest News",
    },
    ...categories,
    {
      id: 100,
      name: "My Bookmark",
    },
  ];

  useEffect(() => {
    getCategories().then(() => {
      if (categories.length > 0) {
        fetchDataByCategory();
      }
    });
  }, []);

  const fetchDataByCategory = () => {
    const categoryMap = categories.map((cat) => {
      return getListNewsByCategory(cat.name).then((response) => ({
        type: cat.name,
        list: response.data,
      }));
    });

    Promise.all(categoryMap).then((result) => {
      setData(result);
    });
  };

  const onChangeTabs = (tabActive, catName) => {
    setIsActive(tabActive);
    if (tabActive === 100) {
      getMyBookmark("");
    } else {
      getListNewsByCategory(catName);
    }
  };

  return (
    <div className="page-news">
      <BaseLayout
        bottomNavIndex={1}
        isCustom={true}
        header={
          <Header
            toPath={PageRoutes.home}
            page="News"
            bgImg={`${process.env.PUBLIC_URL + "/bg-news.jpeg"}`}
          />
        }
      >
        <div>
          <div className="d-flex wrapper-tab justify-content-between align-items-center">
            {tabsCategory.map((cat, index) => (
              <Tabs
                id={cat.id}
                key={index}
                name={cat.name}
                isActive={isActive}
                onClick={() => onChangeTabs(cat.id, cat.name)}
              />
            ))}
          </div>
          {isActive === 0 ? (
            <>
              {data &&
                data.map((dt, index) => {
                  if (dt.list.length > 0) {
                    return (
                      <div key={index}>
                        <Section title={dt.type} />
                        <CarouselSlider data={dt.list} isNews={true} />
                        <br />
                      </div>
                    );
                  }
                })}
            </>
          ) : isActive === 100 ? (
            listBookmark.length > 0 ? (
              listBookmark.map((bookmark) => {
                return (
                  <Category type="bookmark" key={bookmark.id} data={bookmark} />
                );
              })
            ) : (
              <NotFound
                title="No bookmark yet"
                subTitle="Bookmark some news to collect them here."
              />
            )
          ) : dataNews.length > 0 ? (
            dataNews.map((news) => {
              return <Category type="news" key={news.id} data={news} />;
            })
          ) : (
            <NotFound
              title="here is no news"
              subTitle="Stay tuned for more articles in this category."
            />
          )}
        </div>
      </BaseLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.NewsSM.categories,
  dataNews: state.NewsSM.dataNews,
  listBookmark: state.NewsSM.listBookmark,
});

const mapDispatchToProps = (dispatch) => ({
  getCategories: dispatch.NewsSM.getCategories,
  getListNewsByCategory: dispatch.NewsSM.getListNewsByCategory,
  getMyBookmark: dispatch.NewsSM.getMyBookmark,
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsPage);
